<template>
  <section
    class="section"
    @click="resetExpansions"
  >
    <h1>{{ $t('orderList.heading') }}</h1>
    <div
      v-if="this.order"
      class="order"
    >
      <Order
        :order="order"
        :clients="clients"
        :users="users"
        :user="user"
        :fullView="true"
        @update-order="updateOrder"
        @reset-expansions="resetExpansions"
      />
    </div>
  </section>
</template>

<style scoped>
  .order {
    margin: 100px 0;
  }
</style>

<script>
  import Order from '../order/Order.vue';

  export default {
    components: {
      Order
    },
    props: [ 'id', 'user' ],
    data() {
      return {
        order: null,
        users: [],
        clients: []
      };
    },
    beforeCreate: async function() {
      const data = await Promise.all([
        fetch('/api/user'),
        fetch('/api/client')
      ]);
      const json = await Promise.all(data.map(response => response.json()));
      this.users = json[0];
      this.clients = json[1];
      this.fetchOrderData(this.id);
    },
    methods: {
      fetchOrderData: async function (id) {
        const orderData = await fetch(`/api/order/${id}`);
        const orderJson = await orderData.json();
        this.order = {
          ...orderJson,
          _changes: {},
          _errors: {},
          _index: 0,
          _expanded: false,
          _clientName: this.clients.find(client => client.id === orderJson.client_id)?.name ?? '',
          _assignedUserName: this.users.find(user => user.id === orderJson.assigned_user_id)?.name ?? ''
        };
      },
      resetExpansions() {
        this.order._expandedAssignedUserDropdown = false;
      },
      updateOrder(order) {
        this.order = order;
      }
    }
  }
</script>
